module.exports = __webpack_public_path__ + "components/rewards/absolutely-snow/static/logo-ff7652a3a1d1c35d71239f92fc6d7f87.jpg";